<template>
    <aside class="section-pad" id="products-filter">
        <div class="categories-container">

            <section v-for="category in getCategories" :key="category.id">
                <div v-if="category.parent_id === null && category.sub_categories.length === 0">
                    <router-link
                            v-if="category.products_count"
                            class="category_link"
                            :to="'/products/'+ category.slug">
                        <span>{{ category.display_name }} </span>
                        <span class="badge">{{ category.products_count }} </span>
                    </router-link>
                </div>
                <div v-else class="category_filter_container">
                    <label class="category_title"> {{ category.display_name }} </label>
                    <vue-custom-scrollbar class="filter_container">
                        <div v-for="sub in category.sub_categories" :key="sub.slug">
                            <router-link
                                    class="category_link"
                                    v-if="sub.products_count"

                                    :to="'/products/'+ sub.slug">
                                <span>{{ sub.display_name }} </span><span class="badge">{{ sub.products_count }} </span>

                            </router-link>
                        </div>

                    </vue-custom-scrollbar>
                </div>
            </section>
        </div>
    </aside>
</template>

<script>
    import {mapGetters} from "vuex";
    import VueCustomScrollbar from "vue-custom-scrollbar";

    export default {
        props: {
            currentCategory: {
                type: String,
                default: null
            }
        },
        computed: {
            ...mapGetters("categories", ["getCategories"])
        },
        components: {
            VueCustomScrollbar
        }
    };
</script>

<style scoped lang="scss">

    #products-filter {
        clear: both;

        .badge {
            font-size: 12px;
            background: lighten(#11233f, 70%);
            border-radius: 100%;
            width: 25px;
            height: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            color: #000;
            margin-right: 15px;
        }

        .category_title {
            display: block;
            padding: .5rem;
            background-color: #f9f9f9;

        }

        .category_link {
            color: #000;
            display: flex;
            justify-content: space-between;

            padding: .5rem;

        }

        .category_filter_container {
            margin-bottom: 15px;

            .filter_container {
                a {
                    display: flex;
                    justify-content: space-between;
                    width: stretch;
                }

                padding: .5rem 0 1rem .5rem;
                border-bottom: 1px solid #efefef;

                max-height: 250px;
                overflow-x: hidden;
                overflow-y: auto;
            }

            label {
                display: block;
                line-height: 30px;
            }
        }

        .filter-list {
            li:not(:last-child) {
                margin-bottom: 0.313em;
            }

            li {
                a {
                    font-size: 0.938em;
                    line-height: 180%;
                    color: #828282;
                }
            }
        }

        .filter-colors {
            a {
                position: relative;
            }

            .color-circle {
                width: 0.5em;
                height: 0.5em;
                position: absolute;
                left: -0.938em;
                top: 40%;
                transform: translateY(-50%);
                border-radius: 50%;
            }

            .black-bg {
                background: #000;
            }

            .white-bg {
                background: #fff;
            }

            .sliver-bg {
                background: #f1f1f1;
            }

            .light-grey-bg {
                background: #d3d3d3;
            }

            .grey-bg {
                background: #828282;
            }

            .blue-bg {
                background: #8ef1ff;
            }
        }
    }
</style>
